import React, { useState } from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Modal } from 'antd';
import { faArrowRightLong, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from 'react-bootstrap/Card';
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Sec9 } from "./components/Homecomponent";
import { useNavigate } from "react-router-dom/dist";


const localizer = momentLocalizer(moment);

const EService = () => {
    const events = [
        {
            title: 'Event 1',
            start: new Date(2024, 2, 14, 10, 0),
            end: new Date(2024, 2, 14, 12, 0),
        },
        {
            title: 'Event 2',
            start: new Date(2024, 2, 15, 13, 0),
            end: new Date(2024, 2, 15, 15, 0),
        },
    ];
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
        setModalVisible(true);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
    };
    const data = [
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "10 Participants"
        },
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "8 Participants"
        },
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "8 Participants"

        }

    ]

    const navigate = useNavigate();

    return (
        <>
            <PageHeader heading="E-Services" />

            <div className="content_wrap">
                <div className="e_service">
                    <div className='container'>

                        <div className="flex_btw">
                            <h1 className="bold">E-Meetings</h1>
                            <button className="rounded_btn" onClick={() => navigate("/E-service/Announcements")} >View More</button>
                        </div>
                        <Calendar
                            localizer={localizer}
                            events={events}
                            onSelectEvent={handleSelectEvent}

                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 500, marginBottom: "3em" }}
                        />

                        <div className="flex_btw">
                            <h1 className="bold">E-Voting</h1>
                            <button className="rounded_btn" onClick={() => navigate("/E-service/E-Voting")}>View More</button>
                        </div>
                        <div className="cards_wrap">
                            {data.map((e) => {
                                return <>
                                    <Card className="cards">
                                        <h4>{e.title}</h4>
                                        <h6><span className="bold">Date / Time: </span>{e.date}</h6>
                                        <div className="card-content">
                                            <h6><FontAwesomeIcon color="#16b2b0" style={{ paddingRight: "10px" }} icon={faUsers} />{e.participants}</h6>
                                            <button className="rounded_btn" variant="primary">Link</button>
                                        </div>
                                    </Card>
                                </>
                            })}
                        </div>
                        <Sec9 />
                        <h1 className="bold">Advisory Services</h1>
                        <div className="advisory_div">
                            <h5>Advisory update 39 April-June 2021
                                <FontAwesomeIcon icon={faArrowRightLong} />
                            </h5>
                        </div>
                        <div className="advisory_div">
                            <h5>Advisory update 39 April-June 2021
                                <FontAwesomeIcon icon={faArrowRightLong} />
                            </h5>
                        </div>
                        <div className="advisory_div">
                            <h5>Advisory update 39 April-June 2021
                                <FontAwesomeIcon icon={faArrowRightLong} />
                            </h5>
                        </div>
                        <div className="advisory_div">
                            <h5>Advisory update 39 April-June 2021
                                <FontAwesomeIcon icon={faArrowRightLong} />
                            </h5>
                        </div>
                        <div className="advisory_div">
                            <h5>Advisory update 39 April-June 2021
                                <FontAwesomeIcon icon={faArrowRightLong} />
                            </h5>
                        </div>
                        <div className="advisory_div">
                            <h5>Advisory update 39 April-June 2021
                                <FontAwesomeIcon icon={faArrowRightLong} />
                            </h5>
                        </div>

                    </div>
                    <Modal
                        title={selectedEvent ? selectedEvent.title : ''}
                        open={modalVisible}
                        onCancel={handleCloseModal}
                        footer={null}
                    >
                        {selectedEvent && (
                            <div>
                                <p>Start: {moment(selectedEvent.start).format('LLL')}</p>
                                <p>End: {moment(selectedEvent.end).format('LLL')}</p>
                                {/* Add more details as needed */}
                            </div>
                        )}
                    </Modal>



                </div>
            </div >
        </>
    );
};

export default EService;
